import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Table } from 'design-react-kit';
import { RichTextSection } from 'io-sanita-theme/helpers';
import { TableLP } from '@redturtle/iosanita-alp';
import '@redturtle/iosanita-alp/components/Blocks/SearchALP/searchALP.less';

const messages = defineMessages({
  libera_professione: {
    id: 'persona_libera_professione',
    defaultMessage: 'Prestazioni in Libera professione',
  },
});

const PersonaLiberaProfessione = ({ content }) => {
  const intl = useIntl();

  const showSection = content.libera_professione?.length > 0;

  return showSection ? (
    <RichTextSection tag_id="libera_professione" title={intl.formatMessage(messages.libera_professione)}>
      <TableLP content={content} />
    </RichTextSection>
  ) : (
    <></>
  );
};

export default PersonaLiberaProfessione;
